import React from "react";
import { useNavigate } from "react-router-dom";

export default function ForumCard({ post }) {
  const navigate = useNavigate();

  return (
    <div
      className="forum-card"
      onClick={() => navigate(`/post/${post.id}`)}
      style={{ cursor: "pointer" }}
    >


      {/* IMAGE */}
      {post.image && (
        <img
          width={600}
          height={300}
          src={post.image}
          alt={post.title}
          className="forum-image"
        />
      )}
      {/* test */}
      <p></p>
      {/* TAG */}
      {post.tag && (
        <span className={`forum-tag tag-${post.tag}`}>
          {post.tag}
        </span>
      )}
      {/* TITLE */}
      <h3>{post.title}</h3>

      {/* CONTENT PREVIEW */}
      <p>
        {post.content
          ? post.content.substring(0, 100)
          : ""}
        ...
      </p>

      {/* META */}
      <div className="forum-meta">
        <span>By {post.author} </span>
        <span>
          {post.created_at
            ? new Date(post.created_at).toLocaleString()
            : ""}
        </span>
      </div>
    </div>
  );
}